import { useState } from "react";

import y1 from "../assets/gallery/yilbasi/y1.jpeg";
import y2 from "../assets/gallery/yilbasi/y2.jpeg";
import y3 from "../assets/gallery/yilbasi/y3.jpeg";
import e1 from "../assets/gallery/etkinlik/e1.jpeg";

const albums = [
  {
    title: "Yılbaşı",
    cover: y1,
    photos: [y1, y2, y3],
  },
  {
    title: "Etkinlikler",
    cover: e1,
    photos: [e1],
  },
];

const GalleryPage = () => {
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="min-h-screen pt-24 bg-white">
      {/* HEADER */}
      <section className="py-16 bg-gradient-to-br from-yellow-100 via-blue-100 to-pink-100 text-center">
        <h1 className="text-5xl font-black text-gray-900 mb-4">
          Fotoğraf Galerisi
        </h1>
        <p className="text-lg text-gray-600">Anılarımız albümler halinde 💛</p>
      </section>

      {/* ALBUM LİSTESİ */}
      {!selectedAlbum && (
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-3 gap-8">
            {albums.map((album, index) => (
              <div
                key={index}
                onClick={() => setSelectedAlbum(album)}
                className="cursor-pointer group"
              >
                <div className="overflow-hidden rounded-3xl shadow-xl">
                  <img
                    src={album.cover}
                    alt={album.title}
                    className="w-full h-64 object-cover group-hover:scale-110 transition-all duration-500"
                  />
                </div>
                <h3 className="mt-4 text-xl font-bold text-center text-gray-800">
                  {album.title}
                </h3>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* FOTOĞRAF LİSTESİ */}
      {selectedAlbum && (
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-6">
            <button
              onClick={() => setSelectedAlbum(null)}
              className="mb-6 text-lg font-bold text-pink-500 hover:underline"
            >
              ← Albümlere Dön
            </button>

            <h2 className="text-3xl font-black mb-8">{selectedAlbum.title}</h2>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
              {selectedAlbum.photos.map((photo, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedImage(photo)}
                  className="cursor-pointer overflow-hidden rounded-2xl shadow-lg"
                >
                  <img
                    src={photo}
                    alt=""
                    className="w-full h-64 object-cover hover:scale-110 transition-all duration-500"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* MODAL */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-10 right-0 text-white text-4xl font-bold"
            >
              ✕
            </button>

            <img
              src={selectedImage}
              alt=""
              className="w-full max-h-[80vh] object-contain rounded-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
